import CodeBlockNormalizationsPlugin from '../plugins/CodeBlockPlugin/CodeBlockNormalizationsPlugin';
import DividerLineSchemaPlugin from '../plugins/DividerLinePlugin/DividerLineSchemaPlugin';
import EmbedSchemaPlugin from '../plugins/EmbedPlugin/EmbedSchemaPlugin';
import CodeSnippetSchemaPlugin from '../plugins/Formatting/CodeSnippetPlugin/CodeSnippetSchemaPlugin';
import HeadersNormalizationsPlugin from '../plugins/HeadersPlugin/HeadersNormalizationsPlugin';
import InfoBlockNormalizationsPlugin from '../plugins/InfoBlockPlugin/InfoBlockNormalizationsPlugin';
import LabelPillSchemaPlugin from '../plugins/LabelPillPlugin/LabelPillSchemaPlugin';
import LinkNormalizationPlugin from '../plugins/LinkPlugin/LinkNormalization';
import LinkSchemaPlugin from '../plugins/LinkPlugin/LinkSchemaPlugin';
import ListNormalizationsPlugin from '../plugins/ListPlugin/ListNormalizationsPlugin';
import {
  AttachmentSchemaPlugin,
  AudioSchemaPlugin,
  ImageSchemaPlugin,
  VideoSchemaPlugin,
} from '../plugins/MediaPlugin/MediaSchemaPlugin';
import NeverEmptyPlugin from '../plugins/NeverEmptyPlugin/NeverEmptyPlugin';
import ParagraphNormalizationsPlugin from '../plugins/ParagraphPlugin/ParagraphNormalizationsPlugin';
import QuoteNormalizationsPlugin from '../plugins/QuotePlugin/QuoteNormalizationsPlugin';
import LinkCardSchemaPlugin from '../plugins/LinkCardPlugin/LinkCardSchemaPlugin';
import {
  SharedSnippetBlockSchemaPlugin,
  SharedSnippetInlineSchemaPlugin,
} from '../plugins/SharedSnippetPlugin/SharedSnippetSchemaPlugin';
import TableNormalizationPlugin from '../plugins/TablePlugin/TableNormalization';
import { type EditorPlugin } from '../types/aha-editor';
import ReferenceUserSchemaPlugin from '../plugins/ReferencesPlugin/ReferenceUserSchemaPlugin';
import ReferenceRecordSchemaPlugin from '../plugins/ReferencesPlugin/ReferenceRecordSchemaPlugin';
import EmbeddedReportSchemaPlugin from '../plugins/EmbeddedReportPlugin/EmbeddedReportSchemaPlugin';
import EmbeddedWhiteboardSchemaPlugin from '../plugins/EmbeddedWhiteboardPlugin/EmbeddedWhiteboardSchemaPlugin';

const SerializationPlugins: EditorPlugin[] = [
  NeverEmptyPlugin,
  LinkSchemaPlugin,
  LinkNormalizationPlugin,
  EmbedSchemaPlugin,
  DividerLineSchemaPlugin,
  CodeSnippetSchemaPlugin,
  LabelPillSchemaPlugin,
  ImageSchemaPlugin,
  VideoSchemaPlugin,
  AudioSchemaPlugin,
  AttachmentSchemaPlugin,
  SharedSnippetBlockSchemaPlugin,
  SharedSnippetInlineSchemaPlugin,
  ReferenceRecordSchemaPlugin,
  ReferenceUserSchemaPlugin,
  EmbeddedReportSchemaPlugin,
  EmbeddedWhiteboardSchemaPlugin,
  ParagraphNormalizationsPlugin,
  ...HeadersNormalizationsPlugin,
  QuoteNormalizationsPlugin,
  ...CodeBlockNormalizationsPlugin,
  ...InfoBlockNormalizationsPlugin,
  ListNormalizationsPlugin,
  TableNormalizationPlugin,
  LinkCardSchemaPlugin,
];

export default SerializationPlugins;
